const createTemplateable = (route: any) => ({
  id: route.params.templateable_id,
  type: route.params.templateable_type || 'group',
})

export { createTemplateable }
